export type FcmWebConfig = {
  messagingSenderId: string;
  projectId: string;
  appId: string;
  apiKey?: string;
};

export async function initPushInSw(reg: ServiceWorkerRegistration, cfg: FcmWebConfig): Promise<{ok:boolean; error?:string}> {
  const sw = typeof navigator !== 'undefined' ? navigator.serviceWorker : undefined;
  const target = reg.active || sw?.controller;
  if (!target) {
    if (!sw) return { ok: false, error: 'SW_UNAVAILABLE' };
    await new Promise<void>(res => {
      const h = () => { sw.removeEventListener('controllerchange', h); res(); };
      sw.addEventListener('controllerchange', h);
    });
  }
  const chan = new MessageChannel();
  const ackP = new Promise<{ok:boolean; error?:string}>(res => {
    chan.port1.onmessage = (ev) => res(ev.data || { ok:false, error:'NO_DATA_FROM_SW' });
    setTimeout(() => res({ ok:false, error:'ACK_TIMEOUT' }), 8000);
  });
  (reg.active || sw?.controller)?.postMessage({ type:'INIT_FIREBASE', config: cfg }, [chan.port2]);
  return ackP;
}
